<template>
  <div class="confetti-container">
    <lottie-player
      :style="`height: ${confettiSize}; width: ${confettiSize}`"
      src="/Lottie/lottie-confetti.json"
      autoplay
      speed="1"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{ size?: string }>();
const confettiSize = computed(() => props.size || "1000px");
</script>

<style scoped lang="less">
@import (reference) "../styles/bootstrap/variables.less";
.confetti-container {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}
</style>
